module.exports = __webpack_public_path__ + "media/src/img/payment/checkbox-none-a0907e35ae0126720180b145a04b9690.svg";